import React, { useEffect, useRef } from "react";
import * as echarts from "echarts";
import "echarts/lib/component/tooltip";
import "echarts/lib/component/title";
import "echarts/lib/chart/line";
import dayjs from "dayjs";

const BarChart = ({ data, title, style }) => {
  const chartRef = useRef(null);
  const month = dayjs().month();
  const yAxis = Array(month)
    .fill(null)
    .map((_, inde) => `${inde + 1}月`);

  useEffect(() => {
    const chart = echarts.init(chartRef.current);

    const option = {
      title: { text: "数据对比（浏览次数）" },
      tooltip: { trigger: "axis" },
      xAxis: {
        type: "category",
        data: yAxis,
        axisLabel: { rotate: 45 },
      },
      yAxis: {
        type: "value",
      },
      series: [
        {
          name: "私域",
          type: "line",
          stack: "Total",
          data: Array(month)
            .fill(null)
            .map((_, index) => {
              if (!index) {
                return 300;
              }
              return index * 100 + 100;
            }),
        },
        {
          name: "公域",
          type: "line",
          stack: "Total",
          data: Array(month)
            .fill(null)
            .map((_, index) => {
              if (!index) {
                return 300;
              }
              return index * 100 + 100;
            }),
        },
      ],
    };

    chart.setOption(option);

    const handleResize = () => chart.resize();
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
      chart.dispose();
    };
  }, [data, title]);

  return <div ref={chartRef} style={style} />;
};

export default BarChart;
